// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"5a45855c41055bebd5a4","883":"46c1168e5f4e0c08ccc9"}[chunkId] + ".js";
};